var styleDataHash = "84c5d105";
const injectCss = () => {
  var css = `.Pt67K{margin-left:0;margin-right:auto;z-index:1}.Pt67K:not(.mOPA4){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Pt67K:not(.mOPA4){float:none;margin-right:auto}}}@container (width < 640px){.Pt67K:not(.mOPA4){float:none;margin-right:auto}}.Uen8-{margin-left:auto;margin-right:0;z-index:1}.Uen8-:not(.mOPA4){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Uen8-:not(.mOPA4){float:none;margin-left:auto}}}@container (width < 640px){.Uen8-:not(.mOPA4){float:none;margin-left:auto}}.DpL3e{clear:both;display:block}.DpL3e:not(.U37z3){margin-left:auto;margin-right:auto;max-width:100%}.U37z3,.mOPA4{width:100%}.IX8UP .U37z3,.IX8UP .mOPA4{margin:0 -8px;width:auto}.-hRi7{width:fit-content}.B5X7F{margin-left:auto;margin-right:auto;max-width:100%}.v-0Zq{width:min(350px,100%)!important}.IX8UP .v-0Zq{width:50%}.ktVe-{margin-left:auto;margin-right:auto}.IX8UP .ktVe-{width:150px}.KWnrw{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "Pt67K",
  "textWrapNowrap": "mOPA4",
  "alignRight": "Uen8-",
  "alignCenter": "DpL3e",
  "sizeFullWidth": "U37z3",
  "renderedInTable": "IX8UP",
  "sizeOriginal": "-hRi7",
  "sizeContent": "B5X7F",
  "sizeSmall": "v-0Zq",
  "sizeSmallCenter": "ktVe-",
  "flex": "KWnrw"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
